import useGlobalStore from '@/store/useGlobalStore'
import T from '@/components/Helpers/Translate'
import React from 'react'
import { DistributorOnly } from '@/components/Helpers/DistributorOnly'
import Image from 'next/image'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import { Base64 } from '@/lib/utils/shared/base64'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'

const QuickLinks = ({
  isAccountPopover = false,
}: {
  isAccountPopover: boolean
}) => {
  const {
    user: { token, isSignedIn },
    app: { language, alpha3 },
  } = useGlobalStore()
  const { gtm } = useGTM()

  if (!isSignedIn) {
    return null
  }

  const encodedToken = Base64.encode(token ?? '')

  return (
    <div className="my-5 flex items-center justify-between space-x-3 text-primary">
      <a
        className="flex cursor-pointer gap-1.5 text-sm font-medium"
        target="_blank"
        href={`https://www.unicity.com/${alpha3}/${language}/contact`}
        onClick={() => {
          gtm.userMenuNavigationClicked(
            'help_center',
            isAccountPopover ? 'profile_menu' : 'account_menu',
          )
          mixpanelService
            .trackEvent(MixpanelEvent.USER_MENU_NAVIGATION_CLICKED, {
              action: 'help_center',
              event_location: isAccountPopover
                ? 'profile_menu'
                : 'account_menu',
            })
            .catch(() => {})
        }}
      >
        <Image
          height={18}
          width={18}
          src="/icons/chat-bubble-left-ellipsis.svg"
          alt="Check"
        />
        <T>help_center</T>
      </a>
      <a
        className="flex cursor-pointer gap-1.5 text-sm font-medium"
        target="_blank"
        href={`https://library.unicity.com/#/sl/${encodedToken}`}
        onClick={() => {
          gtm.userMenuNavigationClicked(
            'library',
            isAccountPopover ? 'profile_menu' : 'account_menu',
          )

          mixpanelService
            .trackEvent(MixpanelEvent.USER_MENU_NAVIGATION_CLICKED, {
              action: 'library',
              event_location: isAccountPopover
                ? 'profile_menu'
                : 'account_menu',
            })
            .catch(() => {})
        }}
      >
        <Image height={18} width={18} src="/icons/library.svg" alt="Check" />
        <T>library</T>
      </a>
      <DistributorOnly>
        <a
          className="flex cursor-pointer gap-1.5 text-sm font-medium"
          target="_blank"
          href={`https://office.unicity.com/#/login/sl/${encodedToken}`}
          onClick={() => {
            gtm.userMenuNavigationClicked(
              'office',
              isAccountPopover ? 'profile_menu' : 'account_menu',
            )

            mixpanelService
              .trackEvent(MixpanelEvent.USER_MENU_NAVIGATION_CLICKED, {
                action: 'office',
                event_location: isAccountPopover
                  ? 'profile_menu'
                  : 'account_menu',
              })
              .catch(() => {})
          }}
        >
          <Image height={18} width={18} src="/icons/office.svg" alt="Check" />
          <T>office</T>
        </a>
      </DistributorOnly>
    </div>
  )
}

export default QuickLinks
